import { FC, useCallback, useRef } from 'react';
import { useShippingAddress } from '../hooks/ShippingAddress/useShippingAddress';
import { useUpdateShippingAddress } from '../hooks/ShippingAddressForm/useUpdateShippingAddress';
import { useShippingAddressForm } from '../hooks/ShippingAddressForm/useShippingAddressForm';
import { useEmitResetWindow } from '../hooks/common/useEmitResetWindow';
import { useLogging } from '../hooks/common/useLogging';
import { useLoadingAny } from '../hooks/common/useLoadingAny';
import { ShippingAddress } from '../hooks/ShippingAddress/useShippingAddress';
import { Setting } from '../App';

import { NavigationWrapper } from '../components/common/NavigationWrapper';
import { Button } from '../components/common/Button';
import { SectionTitle } from '../components/common/SectionTitle';
import { Form } from '../components/ShippingAddressForm/Form';

export const ShippingAddressForm: FC<{ setting: Setting }> = ({ setting }) => {

  const { subscriptionRef, token } = setting;
  const [{ subscription, loadingSubscriptions }, { getSubscription }] = subscriptionRef;

  const shippingAddress = useShippingAddress(subscription);
  const { formRef } = useShippingAddressForm(shippingAddress);
  const [{ state, isAllValid}, {handleChange, handleBlur}] = formRef;

  const [loadingUpdateShippingAddress, updateShippingAddress] = 
    useUpdateShippingAddress(subscription, getSubscription, token);

  const loadingAny = useLoadingAny([loadingSubscriptions, loadingUpdateShippingAddress])

  // 現在の入力内容stateからパラメータを作成し、そのパラメータを伴ってAPIを叩く
  const update = useCallback(() => {
    if (!state || !subscription) return;

    const stateValue = state.reduce((prev, current) => {
      prev[current.name] = current.value;
      return prev;
    }, {} as any) as ShippingAddress;

    updateShippingAddress(stateValue);
  }, [state, updateShippingAddress]);

  const rootElementReference = useRef<HTMLDivElement | null>(null);
  useEmitResetWindow(rootElementReference, [subscription, state]);

  useLogging('ShippingAddressForm', [state]);

  return (
    <div 
      className={`appContainer shippingAddressForm`}
      ref={rootElementReference}
    >
      <SectionTitle description='変更したい内容を修正したあと、下部の「変更する」ボタンを押してください。'>お届け先情報の変更</SectionTitle>
      <Form state={state} onChange={handleChange} onBlur={handleBlur}/>
      <NavigationWrapper>
        <Button onClick={update} type="primary" disabled={loadingAny || !isAllValid}>変更する</Button>
        <Button internalLink={'/shippingAddress'} type="secondary">もどる</Button>
      </NavigationWrapper>
    </div>
  );
}
